import queryString from "query-string";

class Page {
    static _init() {
        Page.pages = {};
        Page.currentPage = undefined;
        Page.activeRegex = null;
    }

    static init() {
        Page.handlePage();
    }

    static unloadPage() {
        if ("undefined" !== typeof Page.currentPage && "function" === typeof Page.currentPage.unload) {
            try {
                Page.currentPage.unload();
            } catch (e) {
                console.error("Couldn't unload previous page", e);
            }
        }
        Page.currentPage = undefined;
        ``;
        Page.activeRegex = null;
    }

    static handlePage(url = null) {
        this.unloadPage();
        if (url === null) {
            url = window.location.pathname;
        }

        let handler = null;
        let activeRegex = null;

        let bodyClasses = document.getElementsByTagName('body')[0].getAttribute('class');

        Object.keys(Page.pages).forEach((pattern) => {
            if (handler !== null) return;

            let callback = Page.pages[pattern];

            if (bodyClasses.indexOf(pattern) !== -1) {
                handler = callback;
                activeRegex = pattern;
            }
        });

        if (handler !== null) {
            Page.currentPage = handler;
            Page.activeRegex = activeRegex;
            try {
                handler.load();
            } catch (e) {
                console.error("Page handler caused error: ", e);
            }
        } else {
            console.log("No page handler for ", url, Page.pages);
        }
    }

    static register(urls, callback, unload = undefined) {
        if (!(urls instanceof Array)) urls = [urls];
        urls.forEach((url) => {
            Page.pages[url] = {
                load: callback,
                unload: unload,
            };
        });
    }

    static get_query() {
        return queryString.parse(window.location.search, {arrayFormat: "bracket"});
    }
}

Page._init();

export default Page;